<template>
  <div class="container container--narrow pdt-50">
      <div class="t-subtitle6 font-r  t-line-h-26 d-flex -align-items-center">
        {{ question.number }}. {{ question.contents.text }}
        <span class="t-color-mainBtn" v-if="question.essential">*</span>
      </div>
      <div class="mgt-24" v-if="question.contents && question.contents.image">
          <img :src="question.contents.image" alt="" class="b-radius4 survey-star-banner">
      </div>
      <div class="mgt-24">
        <div class="pdl-16 position-relative mdc-menu-anchor menu-container cursor-pointer header-toggle  d-flex justify-content-end align-items-center">
            <div class="t-body3 font-r t-color-bodyGrayA" v-on:click="shortedRatio" v-if="!sortingDefault">{{ $t("736")}}</div>
            <div class="t-body3 font-r t-color-bodyGrayA" v-on:click="shortedRatio" v-else>{{ $t("739")}}</div>
            <i class="material-icons mdc-icon-button t-color-bodyGrayA t-headline6 js--dropdown-toggle" v-on:click="shortedRatio" v-if="!sortingDefault">arrow_drop_up</i>
            <i class="material-icons mdc-icon-button t-color-bodyGrayA t-headline6 js--dropdown-toggle" v-on:click="shortedRatio" v-else>arrow_drop_down</i>
        </div>
    </div>
    <div class="mgt-24">
    <div v-for="(ratio, index) in optionRatio" :key="index">
    <div class="mgb-8 pdt-7 pdb-7 pdl-14 radio-wrapper b-radius4 " :class="question.stars.answer === ratio.view ? 'selected' : ''">
        <div class="d-flex justify-content-between align-items-center">
            <div class="mdc-form-field">
                <div class="mdc-radio customize-radio radio-button-color">
                    <input class="mdc-radio__native-control" 
                    type="radio" name="radios"
                    :checked="question.stars.answer === ratio.view" disabled/>
                    <div class="mdc-radio__background">
                        <div class="mdc-radio__outer-circle"></div>
                        <div class="mdc-radio__inner-circle"></div>
                    </div>
                    <div class="mdc-radio__ripple"></div>
                </div>
                <label for="radios-1" class="t-body1 t-color-quizBlack font-r t-line-h-20 pdl-6">
                    <div class="material-icons t-color-starmark mgr-8" v-for="(i, index1) in ratio.view" :key="index1" :class="question.stars.answer === ratio.view ? 't-color-starmark':'t-color-textfieldDisabledText'">star</div>
                </label>
            </div>
            <div class="t-headline9 t-line-h-22 font-rb mgr-24"  :class="question.stars.answer === ratio.view ? 't-color-lectureRed':'t-color-iconInactive'">{{ Math.round(ratio.ratio) }}%</div>
        </div>
    </div>
    </div>
      <div class="mgt-16" v-if="question.feedback && eachViewFeedback">
        <div class="mdc-card mdc-elevation--z3">
          <div class="pda-16">
            <div class="t-body2">
              {{ $t("738") }}
              <!-- 피드백 -->
            </div>
            <div class="t-body3 t-color-bodyGrayA mgt-16">
              {{ question.feedback }}
            </div>
          </div>
        </div>
      </div>
      <div class="mgt-50"></div>
  </div>
</div>
</template>

<script>
/**
 * 설문 - 별점 문항 피드백 컴포넌트(survey - star point question feedback component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
export default {
  props: ["question", "eachViewFeedback"],

  data() {
    return {
      optionRatio: [],
      sortingDefault: false,
    };
  },

  mounted() {
    this.optionRatio = JSON.parse(JSON.stringify(this.question.stars.ratios));
  },

  methods: {
    shortedRatio(event) {
      this.sortingDefault = !this.sortingDefault;
      if (this.sortingDefault == true) {
        this.optionRatio = this.optionRatio.sort(function (a, b) {
          return b.ratio - a.ratio;
        });
      } else {
        this.optionRatio = JSON.parse(
          JSON.stringify(this.question.stars.ratios)
        );
      }
    },
  },
};
</script>